module.exports = __webpack_public_path__ + "static/section-bg-19c4704e25e81faa9ff097b06326b724.png";